function BlockUMarquee() {
    function init() {
        const elements = jQuery('.block-u-marquee__text');
        for (const iterator of elements) {
            const jElement = jQuery(iterator);
            const time = jElement.data('time') || 5;
            const duration = time*1000;
            jElement.marquee({
                duration
            })
        }
    }
    init();
}
new BlockUMarquee();